import { render, staticRenderFns } from "./ComponentPagination.vue?vue&type=template&id=324f60fa&scoped=true&"
import script from "./ComponentPagination.vue?vue&type=script&lang=js&"
export * from "./ComponentPagination.vue?vue&type=script&lang=js&"
import style0 from "./ComponentPagination.vue?vue&type=style&index=0&id=324f60fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324f60fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
